// src/pages/Services.jsx

import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <div className="min-h-screen bg-[#111111] text-white">

      <Helmet>
        <title>Security Services | SeguraTech</title>

        <meta
          name="description"
          content="Professional security services from SeguraTech including Ajax alarm systems, professional monitoring, managed mobile connectivity, maintenance, secure keyholding and smart home solutions."
        />

        <meta property="og:title" content="Security Services | SeguraTech" />

        <meta
          property="og:description"
          content="Discover the range of professional security services available from SeguraTech."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.seguratech.co.uk/services"
        />

        <meta property="og:image" content="/logo152.png" />
      </Helmet>

      {/* Hero */}

      <section className="max-w-5xl mx-auto px-6 pt-24 pb-20 text-center">

        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-8">
          Security Services
        </h1>

        <p className="text-xl text-white/80 max-w-3xl mx-auto leading-8">
          Whether you're protecting your home or your business, SeguraTech
          provides professional security services designed around reliability,
          simplicity and long-term support.
        </p>

      </section>

      {/* Services */}

      <section className="max-w-6xl mx-auto px-6 pb-24">

        <div className="grid md:grid-cols-2 gap-8">

          {/* Alarm Systems */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Alarm Systems
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              Professionally designed Ajax alarm systems tailored to your home
              or business, combining intelligent protection with simple
              day-to-day operation.
            </p>

            <Link
              to="/alarms"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

          {/* Monitoring */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Professional Monitoring
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              Connect your alarm to a professional monitoring centre, providing
              an additional level of reassurance when you're unable to respond
              yourself.
            </p>

            <Link
              to="/alarms/monitoring"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

          {/* Always Connected */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Always Connected
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              Professionally managed mobile connectivity provides your Ajax
              system with an additional communication path for notifications and
              monitoring, helping keep it connected when your primary internet
              connection becomes unavailable.
            </p>

            <Link
              to="/alarms/always-connected"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

          {/* Maintenance */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Maintenance & Support
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              Ongoing maintenance, servicing and technical support to help keep
              your security system performing reliably throughout its lifetime.
            </p>

            <Link
              to="/alarms/maintenance"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

          {/* Keyholding */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Secure Keyholding
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              A professional keyholding service providing authorised emergency
              access when required, giving you additional peace of mind while
              you're away.
            </p>

            <Link
              to="/secure-keyholding"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

          {/* Smart Home */}

          <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-8">

            <h2 className="text-2xl font-bold text-[#C6A564] mb-4">
              Smart Home Solutions
            </h2>

            <p className="text-white/80 leading-8 mb-6">
              Smart lighting, heating, power and automation designed to make
              your property more convenient, efficient and easier to manage.
            </p>

            <Link
              to="/smarthome"
              className="inline-block text-[#C6A564] hover:underline"
            >
              Learn more →
            </Link>

          </div>

        </div>

      </section>

      {/* CTA */}

      <section className="max-w-5xl mx-auto px-6 pb-24">

        <div className="border border-[#C6A564] rounded-2xl bg-[#1a1a1a] p-12 text-center">

          <h2 className="text-3xl font-bold text-[#C6A564] mb-6">
            Need Some Advice?
          </h2>

          <p className="text-white/80 leading-8 max-w-3xl mx-auto mb-10">
            Choosing the right security solution doesn't have to be complicated.
            Whether you're starting from scratch or upgrading an existing
            system, we're happy to discuss your requirements and recommend the
            most suitable option.x
          </p>

          <Link
            to="/contact"
            className="inline-block bg-[#C6A564] text-[#111111] font-semibold px-10 py-4 rounded-xl hover:opacity-90 transition"
          >
            Contact SeguraTech
          </Link>

        </div>

      </section>

    </div>
  );
}
